import { IPlayerGame } from '@grassrootly/api/entities';
import { provider } from "@grassrootly/api/providers";
import type { GetPlayerPreviousGamesPayload } from './GetPlayerPreviousGames';

export const GetPlayersBestGame = async (params: GetPlayerPreviousGamesPayload): Promise<IPlayerGame | null> =>
  provider.Request("/best-game", params);
